<script setup>
defineProps({
  width: {
    type: Number,
    default: 16,
  },
  height: {
    type: Number,
    default: 16,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="bars-staggered 1" clip-path="url(#clip0_3997_49808)">
      <path
        id="Vector"
        d="M0 2.83333C0 2.64667 0.146667 2.5 0.333333 2.5H12.3333C12.52 2.5 12.6667 2.64667 12.6667 2.83333C12.6667 3.02 12.52 3.16667 12.3333 3.16667H0.333333C0.146667 3.16667 0 3.02 0 2.83333ZM12.3333 13.1667H0.333333C0.146667 13.1667 0 13.3133 0 13.5C0 13.6867 0.146667 13.8333 0.333333 13.8333H12.3333C12.52 13.8333 12.6667 13.6867 12.6667 13.5C12.6667 13.3133 12.52 13.1667 12.3333 13.1667ZM15.6667 7.83333H3.66667C3.48 7.83333 3.33333 7.98 3.33333 8.16667C3.33333 8.35333 3.48 8.5 3.66667 8.5H15.6667C15.8533 8.5 16 8.35333 16 8.16667C16 7.98 15.8533 7.83333 15.6667 7.83333Z"
        fill="#8C8C8C"
      />
    </g>
    <defs>
      <clipPath id="clip0_3997_49808">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
